import * as React from "react";

/* tslint:disable */
export class HomeScreen extends React.Component {
  render() {
    return (
      <div>
        {/*PRELOADER*/}
        <div id="preloader">
          <div className="alignment">
            <div className="v-align center-middle">
              {/* LEFT HEART */}
              <div className="heart-animation">
                <i className="de-icon-heart" />
              </div>
              {/* RIGHT HEART */}
              <div className="heart-animation-reverse">
                <i className="de-icon-heart" />
              </div>
            </div>
          </div>
        </div>{" "}
        {/*END of PRELOADER*/}
        {/* MAIN SLIDER */}
        <section id="main-slider" className="flexslider fullscreen">
          {/* MAIN SLIDER TITLE OUTTER WRAPPER */}
          <div className="slide-title-outter-wrapper">
            {/* MAIN SLIDER TITLE INNER WRAPPER */}
            <div className="slide-title-inner-wrapper">
              {/* TITLE 2 */}
              <div className="slide-title align-middle">
                <div className="container">
                  <div className="row" style={{ marginTop: 250 }}>
                    <div className="col-md-offset-3 col-md-6 animation delay1 fadeInUp">
                      <div className="banner-text withlove medium light">
                        <h1>ALI &amp; IAN</h1>
                      </div>
                      <div id="banner-date">- JULY / 28TH / 2018 -</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* END of MAIN SLIDER TITLE INNER WRAPPER */}
          </div>{" "}
          {/* END of MAIN SLIDER TITLE OUTTER WRAPPER */}
          {/* MAIN SLIDER IMAGES */}
          <ul className="slides">
            <li>
              {/* SLIDE IMAGE */}
              <div
                data-stellar-ratio="0.5"
                className="slide-image"
                style={{
                  backgroundImage: "url(images/ali-and-ian-1.jpg)",
                  backgroundPosition: "top center"
                }}
              />
              {/* SLIDE OVERLAY */}
              <div className="slide-overlay" style={{ opacity: 0 }}>
                {" "}
              </div>
            </li>
          </ul>
          {/* END of MAIN SLIDER IMAGES */}
        </section>
        {/* ENF of MAIN SLIDER */}
        {/* WHERE WHEN SECTION */}
        <section id="where-when">
          <div className="container">
            {/* ROW-1 */}
            <div className="row">
              {/* SECTION TITLE */}
              <div className="col-md-offset-2 col-md-8 text-center">
                <div className="section-title animation fadeInUp">
                  <h2>#WhiteAF18</h2>
                </div>
              </div>
            </div>{" "}
            {/* END of ROW-1 */}
            {/* ROW-2 */}
            <div className="row">
              {/* SECTION TITLE */}
              <div className="col-md-12 text-center">
                <div className="banner-text dark full animation fadeIn">
                  <div className="row">
                    <div className="col-md-4">
                      <h3>JULY / 28TH / 2018</h3>
                    </div>
                    <div className="col-md-4">
                      <div className="border-column">
                        <h3>7 PM - 1 AM</h3>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <h3>GLEN HEAD COUNTRY CLUB</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>{" "}
            {/* END of ROW-2 */}
            {/* ROW-3 */}
            <div className="row">
              <div className="col-md-6 animation fadeIn">
                <div
                  className="de-icon circle small-size inline"
                  style={{ backgroundColor: "#f0394d" }}
                >
                  <i className="de-icon-bell-alt" />
                </div>
                <h3 className="inline">THE WEDDING</h3>
                <p>
                  Our ceremony and reception will take place on Saturday, July
                  28, 2018 at
                </p>
                <p>
                  <b>Glen Head Country Club</b>
                  <br />240 Glen Cove Rd<br />Glen Head, NY 11545
                </p>
                <div
                  className="de-icon circle small-size inline"
                  style={{ backgroundColor: "#f6700e" }}
                >
                  <i className="de-icon-home" />
                </div>
                <h3 className="inline">WHERE TO STAY</h3>
                <p>
                  Blocks of rooms have been reserved at the newly renovated{" "}
                  <a
                    target="_blank"
                    href="http://hiltongardeninn.hilton.com/en/gi/groups/personalized/N/NYCPWGI-FLOWHI-20180726/index.jhtml?WT.mc_id=POG"
                  >
                    Hilton Garden Inn Roslyn
                  </a>, located in the scenic harbor waterfront area of Ali's
                  hometown, Roslyn NY. Transportation will be provided to and
                  from the hotel on the day of the event. Additional hotel
                  options are available online.
                </p>
                <p>
                  Call <a href="tel:+15167447139">516-744-7139</a> and mention
                  the Floam/White room block, or{" "}
                  <a
                    href="http://hiltongardeninn.hilton.com/en/gi/groups/personalized/N/NYCPWGI-FLOWHI-20180726/index.jhtml?WT.mc_id=POG"
                    target="_blank"
                  >
                    book online
                  </a>. King/Queen rooms are available for $219/night and King
                  suites are available for $279/night.
                </p>
                <div
                  className="de-icon circle small-size inline"
                  style={{ backgroundColor: "#99f" }}
                >
                  <i className="de-icon-road" />
                </div>
                <h3 className="inline">GETTING THERE</h3>
                <div className="subheader">
                  <b>By car:</b>
                </div>
                <p>
                  Traffic conditions can vary coming out of the city, because of
                  summer beach traffic. Plan for 90-100 minutes going out on
                  Saturday.
                </p>
                <p>
                  Late at night, traffic is much lighter; expect a 30-45 minute
                  drive going back to the city.
                </p>
                <div className="subheader">
                  <b>By train:</b>
                </div>
                <p>
                  Take the 5:48pm Long Island Railroad from Penn Station on the
                  Port Washington Line to Manhasset station, arriving at 6:28pm.
                </p>
                <p>
                  Cabs are generally available at the station, but you can also
                  order an Uber. Expect a 20-25 minute drive to Glen Head.
                </p>
              </div>
              <div className="col-md-6 animation fadeIn">
                <div
                  id="map-canvas"
                  style={{ border: "15px solid #FFF", marginTop: 20 }}
                />
              </div>
            </div>{" "}
            {/* END of ROW-3 */}
          </div>
        </section>
        {/* PHOTO DIVIDER */}
        <section id="photo-divider-2">
          <div
            className="image-divider fixed-height"
            style={{
              backgroundImage: "url(images/ali-and-ian-2.jpg)",
              height: 450
            }}
            data-stellar-background-ratio="0.3"
          />
        </section>
        {/* GIFT REGISTRY SECTION */}
        <section id="gift-section">
          <div className="container">
            {/* ROW-1 */}
            <div className="row">
              {/* SECTION TITLE */}
              <div className="col-md-offset-2 col-md-8 text-center">
                <div className="section-title animation fadeInUp">
                  <h2>Registry</h2>
                  <p>
                    We are registered at{" "}
                    <a
                      href="http://www.bloomingdales.com/registry/wedding/guest/?registryId=2371622"
                      target="_blank"
                    >
                      Bloomingdales
                    </a>.
                  </p>
                </div>
              </div>
            </div>{" "}
            {/* END of ROW-1 */}
            {/* ROW-1 */}
          </div>
        </section>
        {/*CONTENT SECTION*/}
        <section id="content">
          {/*COUPLE SECTION*/}
          <section id="couple">
            <div className="container">
              {/* ROW-1 */}
              <div className="row">
                {/* SECTION CONTENT */}
                <div className="col-md-6">
                  {/*PHOTO-ITEM*/}
                  <div className="photo-item frame-border animation fadeInLeft">
                    {/*PHOTO*/}
                    <img
                      src="images/ian-photo.jpg"
                      className="hover-animation image-zoom-in"
                    />
                  </div>
                  {/*END of PHOTO-ITEM*/}
                  <div className="his-her-name">
                    <h2 className="text-center">
                      IAN<span className="last-name">-&nbsp;White&nbsp;-</span>
                    </h2>
                    <div className="heart-wrapper">
                      <div className="de-icon circle medium-size custom-heart">
                        <i className="de-icon-heart" />
                      </div>
                    </div>
                  </div>
                  <p className="blurb animation fadeInLeft text-center">
                    <b>Loves:</b> Tennis, beach vacations, acting, Boston
                    sports, building new technology, sci-fi, short girls,
                    karaoke, beating Ali in Scrabble and crossword puzzle races,
                    laughing at/with Ali.<br />
                    <b>Hates:</b> Mushy foods, cold weather, the Yankees
                  </p>
                </div>
                <div className="col-md-6">
                  {/*PHOTO-ITEM*/}
                  <div className="photo-item frame-border animation fadeInRight">
                    {/*PHOTO*/}
                    <img
                      src="images/ali-photo.jpg"
                      className="hover-animation image-zoom-in"
                    />
                  </div>
                  {/*END of PHOTO-ITEM*/}
                  <div className="his-her-name">
                    <h2 className="text-center">
                      ALI<span className="last-name">-&nbsp;Floam&nbsp;-</span>
                    </h2>
                  </div>
                  <p className="blurb animation fadeInRight text-center">
                    <b>Loves:</b> Tennis, beach vacations, golf, the New York
                    Mets, building new startups, rom-coms, blue eyes, karaoke,
                    beating Ian in Boggle and heads-up poker, making Ian laugh.
                    <br />
                    <b>Hates:</b> Smelly foods, cold weather, the Yankees
                  </p>
                </div>
              </div>
            </div>
          </section>
        </section>
        {/* FOOTER SECTION */}
        <footer>
          <div
            className="image-divider fixed-height"
            style={{ backgroundImage: "url(images/ali-and-ian-3.jpg)" }}
            data-stellar-background-ratio="0.5"
          >
            <div className="divider-overlay" />
            {/* Use Center Middle Alignment to align middle the content for fixed-height parallax */}
            <div className="alignment">
              <div className="v-align center-middle">
                <div className="container">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="animation fadeInUp">
                        <div id="thank-you">
                          <div id="thank">Can't</div>
                          <div id="you">Wait!</div>
                        </div>
                      </div>
                      <div className="heart-divider animation delay1 fadeInUp">
                        <span className="white-line" />
                        <i className="de-icon-heart pink-heart" />
                        <i className="de-icon-heart white-heart" />
                        <span className="white-line" />
                      </div>
                      <div
                        id="footer-couple-name"
                        className="animation delay1 fadeInUp"
                      >
                        ALI &amp; IAN
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/screens/HomeScreen.tsx